<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group label="Nama"
                :error="getError('name')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.name"
                    required />
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XFormGroup,
        XCheckboxWrapper,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        }
    },
    data() {
        return {
            fields: {
                name: null,
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit', this.fields)
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
}
</script>